import React, { useState, useEffect } from "react";
import { API } from "../MyApi";
import {
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Button,
  Grid,
  Container,
  Typography,
  Box,
  InputAdornment,
  FormHelperText,
  IconButton,
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import {
  carbontableData,
  cumacData,
  climateOptions,
  departmentToZone,
} from "./ceeSubsidiesData";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import dayjs from "dayjs";
import InfoIcon from "@mui/icons-material/Info";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const familyTypes = [
  "30RB VFD Fan & Control upgrades",
  "30XA VFD Fan & Control upgrades",
];

const unitSizes = {
  "30XA": [
    252, 302, 352, 402, 452, 502, 602, 702, 752, 802, 852, 902, 1002, 1302,
    1382,
  ],
  "30RB": [162, 182, 202, 232, 262, 302, 342, 372, 402, 432, 462, 522],
};

const coolingCapacities = {
  "30XA": [
    267, 391, 318, 378, 426, 473, 601, 654, 691, 759, 807, 875, 960, 1294, 1377,
  ],
  "30RB": [162, 181, 197, 227, 270, 297, 331, 366, 395, 422, 452, 503],
};

const applications = [
  "Commercial - Office - Health - Retail - Other",
  "Industry",
];

const currencies = {
  EUR: "€",
  GBP: "£",
  USD: "$",
};

const callBackendApi = (values) => {
  return "success";
};

const validationSchema = Yup.object({
  projectName: Yup.string(),
  salesRep: Yup.string(),
  date: Yup.date().nullable(),
  projectDescription: Yup.string(),
  projectNotes: Yup.string(),
  familyType: Yup.string().required("Required"),
  unitSize: Yup.string().required("Required"),
  coolingCapacity: Yup.string().required("Required"),
  application: Yup.string().required("Required"),
  pumpFrequency: Yup.number().required("Required"),
  operatingHours: Yup.number()
    .positive("Must be positive")
    .integer("Must be an integer")
    .required("Required"),
  sellingPrice: Yup.number().required("Required"),
  electricityCost: Yup.number().required("Required"),
  ceeSubsidies: Yup.number(),
  ceeValue: Yup.number(),
  carbonIntensity: Yup.number().required("Required"),
  currency: Yup.string().required("Required"),
});

const VfdCalcApp = ({ vfdClacData }) => {
  const [zones, setZones] = useState("");
  const [selectedAirCooled, setSelectedAirCooled] = useState(0);
  const [open, setOpen] = useState(false);
  const [loadopen, setLoadpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [resultvalues, setResultvalues] = useState({});
  const [selectedCurrency, setSelectedCurrency] = useState("€");
  const [selectedLanguage, setSelectedLanguage] = useState("EN");
  const [ceeFieldsHide, setCeeFieldsHide] = useState(false);
  const { t, i18n } = useTranslation();

  const formik = useFormik({
    initialValues: {
      projectName: "",
      salesRep: "",
      date: null,
      projectDescription: "",
      projectNotes: "",
      familyType: "",
      unitSize: "",
      pumpFrequency: 45,
      coolingCapacity: "",
      application: "",
      operatingHours: "",
      sellingPrice: 30000,
      electricityCost: 0.25,
      department: "",
      fiche: "",
      climateCategory: "",
      ceeValorisation: 6.8,
      ceeSubsidies: 0,
      language: "EN",
      nominalPower: 0,
      carbonIntensity: 0.08,
      currency: "EUR",
    },
    validationSchema,
    onSubmit: (values) => {
      console.log("Formik Values:", values);
      console.log("Formik Errors:", formik.errors);

      const vfd_fetchresults = async () => {
        try {
          setLoadpen(true);
          const param = { values: values };
          const resp = await API.postData("/vfd_fetchresults", param);
          setResultvalues(resp?.results);
          console.log("results :: ", resp?.results);

          if (resp?.results) {
            localStorage.setItem("formData", JSON.stringify(values));
            vfdClacData(resp);
            navigate("/vfdoutput");
          }
        } catch (error) {
          console.error("Error fetching cooling capacity:", error);
        }
        setLoadpen(false);
      };
      vfd_fetchresults();
    },
  });

  const handleChangeLanguage = (e) => {
    console.log("i18n Selected Language:", e.toLowerCase());
    i18n.changeLanguage(e.toLowerCase());
  };

  useEffect(() => {
    const saved = localStorage.getItem("formData");
    if (saved) {
      console.log("Saved Form Data:", saved);
      formik.setValues(JSON.parse(saved));

      formik.setFieldValue("unitSize", JSON.parse(saved).unitSize);
      formik.setFieldValue("application", JSON.parse(saved).application);
    }
    localStorage.removeItem("formData");

    const fetchUsername = async () => {
      setLoadpen(true);
      try {
        const user_resp = await API.getData("/get_username", {});
        if (user_resp?.username) {
          formik.setFieldValue("salesRep", user_resp.username);
        }
      } catch (error) {
        console.error("Error fetching username:", error);
      }
      setLoadpen(false);
    };

    fetchUsername();
  }, []);

  const navigate = useNavigate();

  const resetFamilyTypeDependentFields = () => {
    console.log("resetFamilyTypeDependentFields");
    formik.setFieldValue("unitSize", "");
    formik.setFieldValue("ceeSubsidies", "");
    formik.setFieldValue("ceeValue", "");
    formik.setFieldValue("CoolingCapacity", "");
    formik.setFieldValue("application", "");
  };

  // useEffect(() => {
  //   formik.setFieldValue("unitSize", "");
  //   formik.setFieldValue("ceeSubsidies", "");
  //   formik.setFieldValue("ceeValue", "");
  //   formik.setFieldValue("CoolingCapacity", "");
  //   // formik.setFieldValue("application", "");
  // }, [formik.values.familyType]);

  useEffect(() => {
    if (formik.values.language === "FR") {
      setCeeFieldsHide(false);
    } else {
      setCeeFieldsHide(true);
    }
  }, [formik.values.language]);

  const resetFicheceedependencies = () => {
    formik.setFieldValue("department", "");
    formik.setFieldValue("fiche", "");
    formik.setFieldValue("climateCategory", "");
    formik.setFieldValue("ceeValorisation", 6.8);
    formik.setFieldValue("ceeSubsidies", 0);
  };

  // Get Cooling Capacity
  useEffect(() => {
    if (formik.values.unitSize !== "") {
      const fetchCoolingCapacity = async () => {
        try {
          formik.setFieldValue("coolingCapacity", "");

          const param = {
            familyType: formik.values.familyType,
            unitSize: formik.values.unitSize,
          };

          const resp = await API.postData("/vfd_get_coolcap", param);
          formik.setFieldValue(
            "coolingCapacity",
            resp?.coolingCapacity || "N/A"
          );
        } catch (error) {
          console.error("Error fetching cooling capacity:", error);
        }
      };

      fetchCoolingCapacity();
    } else {
      formik.setFieldValue("coolingCapacity", "");
    }
  }, [formik.values.unitSize]);

  useEffect(() => {
    const { department, climateCategory } = formik.values;

    if (department) {
      if (departmentToZone.H1.includes(department)) {
        setZones("H1");
      } else if (departmentToZone.H2.includes(department)) {
        setZones("H2");
      } else if (departmentToZone.H3.includes(department)) {
        setZones("H3");
      }
    }

    if (zones && formik.values.fiche && climateCategory) {
      const airCooledValue =
        cumacData[formik.values.fiche]?.[climateCategory]?.[zones];
      console.log(
        "zones:",
        department,
        ":",
        zones,
        ",Fiche CEE",
        formik.values.fiche,
        ",climateCategory",
        climateCategory
      );
      if (airCooledValue !== undefined) {
        formik.values.airCooled = airCooledValue;
        setSelectedAirCooled(airCooledValue);

        console.log(
          `CEE Subsidy = airCooledValue: ${airCooledValue} × (ceeValorisation: ${
            formik.values.ceeValorisation
          } / 1000) × nominalPower: ${formik.values.nominalPower} = ${
            airCooledValue *
            (formik.values.ceeValorisation / 1000) *
            formik.values.nominalPower
          }`
        );

        formik.setFieldValue(
          "ceeSubsidies",
          Number(
            (
              airCooledValue *
              (formik.values.ceeValorisation / 1000) *
              formik.values.nominalPower
            ).toFixed(2)
          )
        );
      }
    }
  }, [
    formik.values.department,
    formik.values.fiche,
    formik.values.climateCategory,
    formik.values.ceeValorisation,
    formik.values.nominalPower,
  ]);

  return (
    <Container
      maxWidth={false}
      style={{
        paddingLeft: "9rem",
        marginTop: "5rem",
        marginBottom: "5rem",
        width: "90%",
      }}
    >
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loadopen}
      >
        <CircularProgress color="secondary" />
      </Backdrop>
      <form onSubmit={formik.handleSubmit}>
        {/* Section 1 */}
        <Box
          my={10}
          alignItems="center"
          gap={1}
          p={2}
          sx={{ border: "1px solid grey", marginBottom: "1.2rem" }}
          style={{
            marginRight: "5px",
            flex: "100%",
            boxShadow: "rgb(106 156 218 / 71%) 5px 4px 10px 0px",
            alignItems: "flex",
          }}
        >
          <h3>{t("Project Details")}</h3>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={3}>
              <TextField
                fullWidth
                label={t("Project Name")}
                name="projectName"
                value={formik.values.projectName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.projectName &&
                  Boolean(formik.errors.projectName)
                }
                helperText={
                  formik.touched.projectName && formik.errors.projectName
                }
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label={t("Date :")}
                  value={
                    formik.values.date
                      ? dayjs(formik.values.date, "YYYY-MM-DD")
                      : null
                  }
                  onChange={(date) => {
                    if (date) {
                      formik.setFieldValue(
                        "date",
                        dayjs(date).format("YYYY-MM-DD")
                      );
                    } else {
                      formik.setFieldValue("date", null);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      fullWidth
                      {...params}
                      error={formik.touched.date && Boolean(formik.errors.date)}
                      helperText={formik.touched.date && formik.errors.date}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label={t("Sales representative Name:")}
                name="salesRep"
                value={formik.values.salesRep}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.salesRep && Boolean(formik.errors.salesRep)
                }
                helperText={formik.touched.salesRep && formik.errors.salesRep}
              />
            </Grid>

            <Grid item xs={12} md={2}>
              <TextField
                select
                fullWidth
                label="Language"
                name="language"
                value={formik.values.language}
                onChange={(e) => {
                  setSelectedLanguage(e.target.value);
                  handleChangeLanguage(e.target.value);
                  formik.setFieldValue("language", e.target.value);
                }}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.language && Boolean(formik.errors.language)
                }
                helperText={formik.touched.language && formik.errors.language}
              >
                {["EN", "FR", "GE", "NL"].map((lang) => (
                  <MenuItem key={lang} value={lang}>
                    {lang}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={6}>
              <TextField
                fullWidth
                label={t("Project Description")}
                name="projectDescription"
                multiline
                rows={3}
                value={formik.values.projectDescription}
                onChange={formik.handleChange}
                error={
                  formik.touched.projectDescription &&
                  Boolean(formik.errors.projectDescription)
                }
                helperText={
                  formik.touched.projectDescription &&
                  formik.errors.projectDescription
                }
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                fullWidth
                label={t("Project Notes /Comments")}
                name="projectNotes"
                multiline
                rows={3}
                value={formik.values.projectNotes}
                onChange={formik.handleChange}
              />
            </Grid>
          </Grid>
        </Box>
        {/* Section 2 */}
        <Box
          my={3}
          alignItems="center"
          gap={1}
          p={2}
          sx={{ border: "1px solid grey", marginBottom: "0rem" }}
          style={{
            marginRight: "5px",
            flex: "100%",
            boxShadow: "rgb(106 156 218 / 71%) 5px 4px 10px 0px",
            alignItems: "flex",
          }}
        >
          <h3>{t("VFD Inputs")}</h3>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <FormControl
                fullWidth
                error={
                  formik.touched.familyType && Boolean(formik.errors.familyType)
                }
              >
                <InputLabel>{t("Type of Upgrade")}</InputLabel>
                <Select
                  name="familyType"
                  value={formik.values.familyType}
                  onChange={(e) => {
                    formik.handleChange(e);
                    resetFamilyTypeDependentFields();
                  }}
                >
                  <MenuItem
                    key="30XA VFD Fan & Control upgrades"
                    value="30XA VFD Fan & Control upgrades"
                  >
                    {t("30XA VFD Fan & Control upgrades")}
                  </MenuItem>
                  <MenuItem
                    key="30RB VFD Fan & Control upgrades"
                    value="30RB VFD Fan & Control upgrades"
                  >
                    {t("30RB VFD Fan & Control upgrades")}
                  </MenuItem>
                </Select>
                {formik.touched.familyType && formik.errors.familyType && (
                  <FormHelperText>{formik.errors.familyType}</FormHelperText>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={3}>
              <FormControl
                fullWidth
                error={
                  formik.touched.unitSize && Boolean(formik.errors.unitSize)
                }
              >
                <InputLabel>{t("Unit Size")}</InputLabel>
                <Select
                  name="unitSize"
                  value={formik.values.unitSize}
                  onChange={formik.handleChange}
                  disabled={formik.values.familyType === ""}
                >
                  {unitSizes[formik.values.familyType?.split(" ")[0]]?.map(
                    (size) => (
                      <MenuItem key={size} value={size}>
                        {size}
                      </MenuItem>
                    )
                  )}
                </Select>
                {formik.touched.unitSize && formik.errors.unitSize && (
                  <FormHelperText>{formik.errors.unitSize}</FormHelperText>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={3}>
              <TextField
                fullWidth
                label={t("Cooling Capacity")}
                name="coolingCapacity"
                type="string"
                disabled
                value={formik.values.coolingCapacity}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">kWf</InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiInputBase-input.Mui-disabled": {
                    color: "black", // Ensures text stays black
                    WebkitTextFillColor: "black",
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl
                fullWidth
                error={
                  formik.touched.application &&
                  Boolean(formik.errors.application)
                }
              >
                <InputLabel id="application-label">
                  {t("Application")}
                </InputLabel>
                <Select
                  labelId="application-label"
                  name="application"
                  value={formik.values.application}
                  onChange={formik.handleChange}
                  label={t("Application")}
                >
                  <MenuItem
                    key="Commercial - Office - Health - Retail - Other"
                    value="Commercial - Office - Health - Retail - Other"
                  >
                    {t("Commercial - Office - Health - Retail - Other")}
                  </MenuItem>
                  <MenuItem key="Industry" value="Industry">
                    {t("Industry")}
                  </MenuItem>
                </Select>
                {formik.touched.application && formik.errors.application && (
                  <FormHelperText>{formik.errors.application}</FormHelperText>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                error={
                  formik.touched.operatingHours &&
                  Boolean(formik.errors.operatingHours)
                }
                fullWidth
                label={t("Operating Hours / Year")}
                name="operatingHours"
                type="number"
                value={formik.values.operatingHours}
                onChange={formik.handleChange}
              />
              {formik.touched.operatingHours &&
                formik.errors.operatingHours && (
                  <FormHelperText>
                    {formik.errors.operatingHours}
                  </FormHelperText>
                )}
            </Grid>
          </Grid>
        </Box>
        {/* Section 3 */}
        <Box
          my={3}
          alignItems="center"
          gap={1}
          p={2}
          sx={{ border: "1px solid grey" }}
          style={{
            marginRight: "5px",
            flex: "100%",
            boxShadow: "rgb(106 156 218 / 71%) 5px 4px 10px 0px",
            alignItems: "flex",
          }}
        >
          <Grid container spacing={3}>
            {/* Section Title */}
            <Grid item xs={12}>
              <h3>{t("Calculation Assumptions")}</h3>
            </Grid>

            {/* Selling Price for the upgrade */}
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label={t("Selling Price for the upgrade")}
                name="sellingPrice"
                type="number"
                value={formik.values.sellingPrice}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.sellingPrice &&
                  Boolean(formik.errors.sellingPrice)
                }
                helperText={
                  formik.touched.sellingPrice && formik.errors.sellingPrice
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {selectedCurrency}
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            {/* Electricity Cost */}
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label={t("Electricity Cost")}
                name="electricityCost"
                type="number"
                value={formik.values.electricityCost}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.electricityCost &&
                  Boolean(formik.errors.electricityCost)
                }
                helperText={
                  formik.touched.electricityCost &&
                  formik.errors.electricityCost
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {selectedCurrency}/kWh
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <TextField
                select
                fullWidth
                label={t("Currency")}
                name="currency"
                value={formik.values.currency}
                onChange={(e) => {
                  setSelectedCurrency(currencies[e.target.value]);
                  formik.setFieldValue("currency", e.target.value);
                  resetFicheceedependencies();
                }}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.currency && Boolean(formik.errors.currency)
                }
                helperText={formik.touched.currency && formik.errors.currency}
              >
                {Object.entries(currencies).map(([key, label]) => (
                  <MenuItem key={key} value={key}>
                    {key}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            {/* Carbon Intensity Conversion */}
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label={t("Carbon Intensity conversion")}
                name="carbonIntensity"
                type="number"
                value={formik.values.carbonIntensity}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.carbonIntensity &&
                  Boolean(formik.errors.carbonIntensity)
                }
                helperText={
                  formik.touched.carbonIntensity &&
                  formik.errors.carbonIntensity
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <span>kgCO₂/kWh</span>
                      <IconButton onClick={handleOpen} edge="end">
                        <InfoIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid
              item
              xs={12}
              md={1.75}
              sx={{ display: ceeFieldsHide ? "none" : "block" }}
            >
              <TextField
                fullWidth
                type="number"
                label={t("Nominal Electrical Power")}
                name="nominalPower"
                value={formik.values.nominalPower}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.nominalPower &&
                  Boolean(formik.errors.nominalPower)
                }
                helperText={
                  formik.touched.nominalPower && formik.errors.nominalPower
                }
                InputProps={{
                  inputProps: { min: 0, step: 0.1 },
                  endAdornment: (
                    <InputAdornment position="end">kW</InputAdornment>
                  ),
                }}
              />
            </Grid>

            {/* CEE Subsidies (FR) */}
            <Grid
              item
              xs={12}
              md={2}
              sx={{ display: ceeFieldsHide ? "none" : "block" }}
            >
              <TextField
                fullWidth
                select
                label={t("Department/Zone")}
                name="department"
                value={formik.values.department}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={ceeFieldsHide}
                error={
                  formik.touched.department && Boolean(formik.errors.department)
                }
                helperText={
                  formik.touched.department && formik.errors.department
                }
              >
                {Object.entries(departmentToZone).flatMap(
                  ([zone, departments]) =>
                    departments.map((dept) => (
                      <MenuItem key={dept} value={dept}>
                        {dept} - ({zone})
                      </MenuItem>
                    ))
                )}
              </TextField>
            </Grid>

            {/* CEE Value (FR) */}
            <Grid
              item
              xs={12}
              md={1.75}
              sx={{ display: ceeFieldsHide ? "none" : "block" }}
            >
              <TextField
                fullWidth
                select
                label={t("Fiche CEE")}
                name="fiche"
                value={formik.values.fiche}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={ceeFieldsHide || !formik.values.department}
                error={formik.touched.fiche && Boolean(formik.errors.fiche)}
                helperText={formik.touched.fiche && formik.errors.fiche}
              >
                {Object.keys(climateOptions).map((ficheKey) => (
                  <MenuItem key={ficheKey} value={ficheKey}>
                    {ficheKey}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid
              item
              xs={12}
              md={3}
              sx={{ display: ceeFieldsHide ? "none" : "block" }}
            >
              <TextField
                fullWidth
                select
                label={t("Climate Category")}
                name="climateCategory"
                value={formik.values.climateCategory}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={
                  ceeFieldsHide ||
                  !formik.values.fiche ||
                  !formik.values.department
                }
                error={
                  formik.touched.climateCategory &&
                  Boolean(formik.errors.climateCategory)
                }
                helperText={
                  formik.touched.climateCategory &&
                  formik.errors.climateCategory
                }
              >
                {Object.keys(climateOptions).map((key) => {
                  if (
                    formik.values.department &&
                    formik.values.fiche &&
                    formik.values.fiche === key
                  ) {
                    return climateOptions[key].map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ));
                  }
                  return null;
                })}
              </TextField>
            </Grid>

            {/* CEE Value (FR) */}
            <Grid
              item
              xs={12}
              md={1.75}
              sx={{ display: ceeFieldsHide ? "none" : "block" }}
            >
              <Tooltip
                title={
                  <React.Fragment>
                    <div>
                      Average value estimated (March 2025) by our partner EDE.
                      Value to be modified if necessary
                    </div>
                  </React.Fragment>
                }
                placement="bottom-end"
                arrow
              >
                <TextField
                  fullWidth
                  label={t("CEE Valorisation")}
                  name="ceeValorisation"
                  type="number"
                  value={formik.values.ceeValorisation}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={ceeFieldsHide || !formik.values.climateCategory}
                  error={
                    formik.touched.ceeValorisation &&
                    Boolean(formik.errors.ceeValorisation)
                  }
                  helperText={
                    formik.touched.ceeValorisation &&
                    formik.errors.ceeValorisation
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {selectedCurrency}/MWh
                      </InputAdornment>
                    ),
                  }}
                />
              </Tooltip>
            </Grid>

            <Grid
              item
              xs={12}
              md={1.75}
              sx={{ display: ceeFieldsHide ? "none" : "block" }}
            >
              <TextField
                fullWidth
                label={t("CEE Subsidies")}
                name="ceesubsidies"
                type="number"
                value={formik.values.ceeSubsidies}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={ceeFieldsHide}
                error={
                  formik.touched.ceesubsidies &&
                  Boolean(formik.errors.ceesubsidies)
                }
                helperText={
                  formik.touched.ceesubsidies && formik.errors.ceesubsidies
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">€</InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiInputBase-input.Mui-disabled": {
                    color: "black", // Ensures text stays black
                    WebkitTextFillColor: "black",
                  },
                }}
              />
            </Grid>

            {/* <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label={t("Mini Pump Frequency")}
                name="pumpFrequency"
                type="number"
                value={formik.values.pumpFrequency}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.pumpFrequency &&
                  Boolean(formik.errors.pumpFrequency)
                }
                helperText={
                  formik.touched.pumpFrequency && formik.errors.pumpFrequency
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">HZ</InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiInputBase-input.Mui-disabled": {
                    color: "black", // Ensures text stays black
                    WebkitTextFillColor: "black",
                  },
                }}
              />
            </Grid> */}
          </Grid>
        </Box>

        <Grid
          style={{ marginTop: "3rem", justifyContent: "center" }}
          container
          spacing={2}
        >
          <Grid style={{ paddingTop: 8 }} item xs={12} sm={2}>
            <Button
              size="large"
              onClick={() => formik.handleSubmit()}
              fullWidth
              variant="contained"
            >
              {t("Submit")}
            </Button>
          </Grid>

          <Grid style={{ paddingTop: 8 }} item xs={12} sm={2}>
            <Button
              size="large"
              color="error"
              onClick={() => formik.resetForm()}
              fullWidth
              variant="contained"
            >
              {t("Clear All")}
            </Button>
          </Grid>
        </Grid>

        {/* Modal for Carbon Reference Table */}
        <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
          <DialogTitle sx={{ fontWeight: "bold" }}>
            Carbon Intensity Conversion Table
          </DialogTitle>
          <DialogContent>
            <TableContainer component={Paper}>
              <Table
                sx={{
                  border: "1px solid black",
                  borderCollapse: "collapse",
                }}
              >
                <TableHead
                  sx={{
                    borderBottom: "1px solid black",
                    "& th": {
                      border: "1px solid black",
                    },
                  }}
                >
                  <TableRow sx={{ backgroundColor: "aliceblue" }}>
                    <TableCell></TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      Carbon Intensity Conversion
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      colSpan={3}
                      align="center"
                    >
                      Indicative Energy Price (05/24) €/kWh
                    </TableCell>
                  </TableRow>
                  <TableRow sx={{ backgroundColor: "aliceblue" }}>
                    <TableCell sx={{ fontWeight: "bold" }}>Country</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      kg CO₂e per kWh
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      20 - 500 MWh/year
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      500 - 2000 MWh/year
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {carbontableData.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>{row.country}</TableCell>
                      <TableCell>{row.intensity}</TableCell>
                      <TableCell>{row.price1 || "N/A"}</TableCell>
                      <TableCell>{row.price2 || "N/A"}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContent>
        </Dialog>
      </form>
    </Container>
  );
};

export default VfdCalcApp;
